export default "__VITE_ASSET__C7QNH_kK__"